var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button, Typography, Row, Column, GridContainer, screenClassMinWidths } from '@vp/swan';
import { css, cx } from '@emotion/css';
const stylePrimaryErrorHeader = css `
    hyphens: none;
`;
const styleSecondaryErrorHeader = css `
    margin: 1em 0;
    hyphens: none;
    font-size: 12px;
    padding: 0.5vw 1vw 1vw 1vw;

    @media only screen and (min-width: ${screenClassMinWidths['sm']}px) {
        padding: 0 0 1vw 0;
        font-size: 16px;
    }
`;
const styleErrorCTA = css `
    white-space: normal !important;
    @media only screen and (min-width: ${screenClassMinWidths['sm']}px) {
        margin-right: 40px;
    }
`;
const styleErrorHeaderCol = css `
    text-align: center;
    @media only screen and (min-width: ${screenClassMinWidths['md']}px) {
        text-align: left;
    }
`;
const styleErrorButtonContainer = css `
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0 0 100px 0;
    @media only screen and (min-width: ${screenClassMinWidths['md']}px) {
        margin: 16px 0 0 0;
        justify-content: left;
    }
`;
function ErrorMessagingCTA(_a) {
    var { errorHeader, errorSubHeader, primaryButtonMessage, primaryOnClick, secondaryButtonMessage, secondaryOnClick } = _a, rest = __rest(_a, ["errorHeader", "errorSubHeader", "primaryButtonMessage", "primaryOnClick", "secondaryButtonMessage", "secondaryOnClick"]);
    return (React.createElement(GridContainer, Object.assign({}, rest),
        React.createElement(Row, null,
            React.createElement(Column, { className: cx(styleErrorHeaderCol, 'p-0'), span: 12 },
                React.createElement(Typography, { className: stylePrimaryErrorHeader, component: "h3" }, errorHeader))),
        React.createElement(Row, null,
            React.createElement(Column, { className: cx(styleErrorHeaderCol, 'p-0'), span: 12 },
                React.createElement(Typography, { className: styleSecondaryErrorHeader }, errorSubHeader))),
        React.createElement(Row, null,
            React.createElement("div", { className: styleErrorButtonContainer },
                React.createElement(Button, { className: styleErrorCTA, onClick: primaryOnClick, component: "a", skin: "primary", my: 1 }, primaryButtonMessage),
                secondaryButtonMessage && secondaryOnClick && (React.createElement(Button, { className: styleErrorCTA, onClick: secondaryOnClick, component: "a", skin: "secondary", my: 1 }, secondaryButtonMessage))))));
}
ErrorMessagingCTA.displayName = 'ErrorPageCTA';
export default ErrorMessagingCTA;
//# sourceMappingURL=ErrorMessagingCTA.js.map